// One resolver for displayed addresses, REST calls and WebSocket calls.
// Keep this module independent of Vite so generated Skill templates can use
// an already-resolved URL without changing their plain Node test entry point.
export const isLocalDev = () =>
  typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/.test(window.location.hostname);

export function createGatewayHelpers(config) {
  const authority = (host) => String(host || '').trim().replace(/^(?:https?|wss?):\/\//i, '').split('/')[0];
  const buildGatewayUrl = (host, integrationMode) => {
    const value = authority(host);
    if (!value) return '';
    const prefix = value.split('.')[0].split(':')[0];
    const sandbox = integrationMode === 'SANDBOX_PROVIDER_V1';
    if (isLocalDev() && config.gatewayMode !== 'remote') {
      return sandbox
        ? `http://${prefix}.sandbox.localhost:${config.sandboxLocalPort}`
        : `http://${prefix}.localhost:${config.gatewayLocalPort}`;
    }
    if (sandbox) return `https://${prefix}.${config.sandboxDomain}`;
    return `https://${/[.:]/.test(value) ? value : `${prefix}.${config.gatewayDomain}`}`;
  };
  const gatewayHost = (host, integrationMode) => buildGatewayUrl(host, integrationMode).replace(/^https?:\/\//, '');
  const gatewaySuffix = (integrationMode) => gatewayHost('prefix', integrationMode).slice('prefix'.length);
  const buildWsGatewayUrl = (host, clientPath = '/', query = {}) => {
    const value = authority(host);
    if (!value) return '';
    const prefix = value.split('.')[0].split(':')[0];
    const base = isLocalDev() && config.gatewayMode !== 'remote'
      ? `ws://${prefix}.localhost:${config.wsGatewayLocalPort}`
      : `wss://${/[.:]/.test(value) ? value : `${prefix}.${config.gatewayDomain}`}`;
    const path = clientPath ? (clientPath.startsWith('/') ? clientPath : '/' + clientPath) : '/';
    const search = Object.entries(query || {})
      .filter(([, v]) => v !== '' && v !== null && v !== undefined)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
    return base + path + (search ? (path.includes('?') ? '&' : '?') + search : '');
  };
  return { buildGatewayUrl, buildWsGatewayUrl, gatewayHost, gatewaySuffix };
}
